const uniq = array => {
  return array.filter((el, index, arr) => index === arr.indexOf(el))
}

export default {
  ADD_LOADING(state, loaderMessage) {
    state.activeLoaders.push(loaderMessage)
    state.activeLoaders = uniq(state.activeLoaders)
  },
  REMOVE_LOADING(state, loaderMessage) {
    state.activeLoaders = uniq(state.activeLoaders).filter(p => p !== loaderMessage)
  }
}
